import { _ as _extends } from '../../dist/extends-a2cb9f0c.esm.js';
import React__default, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Slider from 'rc-slider';
import { u as useTheme } from '../../dist/useTheme-90e8e2c2.esm.js';
import { A as AppText } from '../../dist/index-6b88191c.esm.js';
import 'react-i18next';
import '../../dist/index-0ee62650.esm.js';
import '@fortawesome/react-native-fontawesome';
import 'react-native-popable';
import 'markdown-it';
import 'mermaid';
import '../../dist/index-3256db5b.esm.js';
import '@fortawesome/pro-light-svg-icons/faAdjust';
import '@fortawesome/pro-light-svg-icons/faAlignCenter';
import '@fortawesome/pro-light-svg-icons/faAlignLeft';
import '@fortawesome/pro-light-svg-icons/faAlignRight';
import '@fortawesome/pro-light-svg-icons/faArrowCircleRight';
import '@fortawesome/pro-light-svg-icons/faArrowSquareLeft';
import '@fortawesome/pro-light-svg-icons/faArrowToRight';
import '@fortawesome/pro-light-svg-icons/faBan';
import '@fortawesome/pro-light-svg-icons/faBars';
import '@fortawesome/pro-light-svg-icons/faBell';
import '@fortawesome/pro-light-svg-icons/faBezierCurve';
import '@fortawesome/pro-light-svg-icons/faBold';
import '@fortawesome/pro-light-svg-icons/faBookOpen';
import '@fortawesome/pro-light-svg-icons/faBookReader';
import '@fortawesome/pro-light-svg-icons/faBookmark';
import '@fortawesome/pro-light-svg-icons/faBooks';
import '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import '@fortawesome/pro-light-svg-icons/faBrain';
import '@fortawesome/pro-light-svg-icons/faHeadSideBrain';
import '@fortawesome/pro-light-svg-icons/faBrowser';
import '@fortawesome/pro-light-svg-icons/faCalendarDay';
import '@fortawesome/pro-light-svg-icons/faCalendarEdit';
import '@fortawesome/pro-light-svg-icons/faFileChartLine';
import '@fortawesome/pro-light-svg-icons/faChartColumn';
import '@fortawesome/pro-light-svg-icons/faChartNetwork';
import '@fortawesome/pro-light-svg-icons/faCheckCircle';
import '@fortawesome/pro-light-svg-icons/faChevronDoubleUp';
import '@fortawesome/pro-light-svg-icons/faChevronDown';
import '@fortawesome/pro-light-svg-icons/faChevronLeft';
import '@fortawesome/pro-light-svg-icons/faScannerTouchscreen';
import '@fortawesome/pro-light-svg-icons/faChevronRight';
import '@fortawesome/pro-light-svg-icons/faChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircle';
import '@fortawesome/pro-light-svg-icons/faClipboard';
import '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import '@fortawesome/pro-light-svg-icons/faSparkles';
import '@fortawesome/pro-light-svg-icons/faClock';
import '@fortawesome/pro-light-svg-icons/faClone';
import '@fortawesome/pro-light-svg-icons/faCloudDownload';
import '@fortawesome/pro-light-svg-icons/faCloudUpload';
import '@fortawesome/pro-light-svg-icons/faCode';
import '@fortawesome/pro-light-svg-icons/faCodeMerge';
import '@fortawesome/pro-light-svg-icons/faCog';
import '@fortawesome/pro-light-svg-icons/faCommentAltLines';
import '@fortawesome/pro-light-svg-icons/faCommentLines';
import '@fortawesome/pro-light-svg-icons/faCommentsAlt';
import '@fortawesome/pro-light-svg-icons/faCompressAlt';
import '@fortawesome/pro-light-svg-icons/faCopy';
import '@fortawesome/pro-light-svg-icons/faCreditCard';
import '@fortawesome/pro-light-svg-icons/faDatabase';
import '@fortawesome/pro-light-svg-icons/faDollarSign';
import '@fortawesome/pro-light-svg-icons/faEdit';
import '@fortawesome/pro-light-svg-icons/faEllipsisH';
import '@fortawesome/pro-light-svg-icons/faEllipsisV';
import '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import '@fortawesome/pro-light-svg-icons/faEraser';
import '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import '@fortawesome/pro-light-svg-icons/faExpandAlt';
import '@fortawesome/pro-light-svg-icons/faExpandWide';
import '@fortawesome/pro-light-svg-icons/faEye';
import '@fortawesome/pro-light-svg-icons/faEyeSlash';
import '@fortawesome/pro-light-svg-icons/faFile';
import '@fortawesome/pro-light-svg-icons/faFileAlt';
import '@fortawesome/pro-light-svg-icons/faFileCode';
import '@fortawesome/pro-light-svg-icons/faFileCsv';
import '@fortawesome/pro-light-svg-icons/faFileExcel';
import '@fortawesome/pro-light-svg-icons/faFileExport';
import '@fortawesome/pro-light-svg-icons/faFileImport';
import '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import '@fortawesome/pro-light-svg-icons/faFilePdf';
import '@fortawesome/pro-light-svg-icons/faFilePowerpoint';
import '@fortawesome/pro-light-svg-icons/faFileSignature';
import '@fortawesome/pro-light-svg-icons/faFileUpload';
import '@fortawesome/pro-light-svg-icons/faFileWord';
import '@fortawesome/pro-light-svg-icons/faFolder';
import '@fortawesome/pro-light-svg-icons/faFont';
import '@fortawesome/pro-light-svg-icons/faGameBoardAlt';
import '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import '@fortawesome/pro-light-svg-icons/faGlobePointer';
import '@fortawesome/pro-light-svg-icons/faGripLinesVertical';
import '@fortawesome/pro-light-svg-icons/faGripVertical';
import '@fortawesome/pro-light-svg-icons/faH1';
import '@fortawesome/pro-light-svg-icons/faH2';
import '@fortawesome/pro-light-svg-icons/faHashtag';
import '@fortawesome/pro-light-svg-icons/faHighlighter';
import '@fortawesome/pro-light-svg-icons/faHistory';
import '@fortawesome/pro-light-svg-icons/faHomeAlt';
import '@fortawesome/pro-light-svg-icons/faImage';
import '@fortawesome/pro-light-svg-icons/faInbox';
import '@fortawesome/pro-light-svg-icons/faIndent';
import '@fortawesome/pro-light-svg-icons/faInfoCircle';
import '@fortawesome/pro-light-svg-icons/faItalic';
import '@fortawesome/pro-light-svg-icons/faKeyboard';
import '@fortawesome/pro-light-svg-icons/faLanguage';
import '@fortawesome/pro-light-svg-icons/faLaptopCode';
import '@fortawesome/pro-light-svg-icons/faLayerGroup';
import '@fortawesome/pro-light-svg-icons/faLightbulbExclamation';
import '@fortawesome/pro-light-svg-icons/faLink';
import '@fortawesome/pro-light-svg-icons/faListOl';
import '@fortawesome/pro-light-svg-icons/faListUl';
import '@fortawesome/pro-light-svg-icons/faLock';
import '@fortawesome/pro-light-svg-icons/faLockOpen';
import '@fortawesome/pro-light-svg-icons/faMeteor';
import '@fortawesome/pro-light-svg-icons/faMicrophone';
import '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt';
import '@fortawesome/pro-light-svg-icons/faNetworkWired';
import '@fortawesome/pro-light-svg-icons/faPaintRoller';
import '@fortawesome/pro-light-svg-icons/faPaperPlaneTop';
import '@fortawesome/pro-light-svg-icons/faPen';
import '@fortawesome/pro-light-svg-icons/faPlanetRinged';
import '@fortawesome/pro-light-svg-icons/faPlus';
import '@fortawesome/pro-light-svg-icons/faPlusCircle';
import '@fortawesome/pro-light-svg-icons/faPowerOff';
import '@fortawesome/pro-light-svg-icons/faQuestion';
import '@fortawesome/pro-light-svg-icons/faQuestionCircle';
import '@fortawesome/pro-light-svg-icons/faQuoteLeft';
import '@fortawesome/pro-light-svg-icons/faRedo';
import '@fortawesome/pro-light-svg-icons/faReply';
import '@fortawesome/pro-light-svg-icons/faRocketLaunch';
import '@fortawesome/pro-light-svg-icons/faSatelliteDish';
import '@fortawesome/pro-light-svg-icons/faScrubber';
import '@fortawesome/pro-light-svg-icons/faSearch';
import '@fortawesome/pro-light-svg-icons/faSearchMinus';
import '@fortawesome/pro-light-svg-icons/faSearchPlus';
import '@fortawesome/pro-light-svg-icons/faShareAlt';
import '@fortawesome/pro-light-svg-icons/faSignOut';
import '@fortawesome/pro-light-svg-icons/faSlidersV';
import '@fortawesome/pro-light-svg-icons/faSlidersVSquare';
import '@fortawesome/pro-light-svg-icons/faSpinner';
import '@fortawesome/pro-light-svg-icons/faStopCircle';
import '@fortawesome/pro-light-svg-icons/faStream';
import '@fortawesome/pro-light-svg-icons/faStrikethrough';
import '@fortawesome/pro-light-svg-icons/faSync';
import '@fortawesome/pro-light-svg-icons/faTag';
import '@fortawesome/pro-light-svg-icons/faTerminal';
import '@fortawesome/pro-light-svg-icons/faThumbsDown';
import '@fortawesome/pro-light-svg-icons/faThumbsUp';
import '@fortawesome/pro-light-svg-icons/faThumbtack';
import '@fortawesome/pro-light-svg-icons/faTimes';
import '@fortawesome/pro-light-svg-icons/faTimesCircle';
import '@fortawesome/pro-light-svg-icons/faTrash';
import '@fortawesome/pro-light-svg-icons/faTypewriter';
import '@fortawesome/pro-light-svg-icons/faUnderline';
import '@fortawesome/pro-light-svg-icons/faUndo';
import '@fortawesome/pro-light-svg-icons/faUnlink';
import '@fortawesome/pro-light-svg-icons/faUser';
import '@fortawesome/pro-light-svg-icons/faUserCircle';
import '@fortawesome/pro-light-svg-icons/faUserLock';
import '@fortawesome/pro-light-svg-icons/faUserBeardBolt';
import '@fortawesome/pro-light-svg-icons/faUserRobot';
import '@fortawesome/pro-light-svg-icons/faUserSecret';
import '@fortawesome/pro-light-svg-icons/faUserAstronaut';
import '@fortawesome/pro-light-svg-icons/faUserShield';
import '@fortawesome/pro-light-svg-icons/faUsers';
import '@fortawesome/pro-light-svg-icons/faUsersCog';
import '@fortawesome/pro-light-svg-icons/faVial';
import '@fortawesome/pro-light-svg-icons/faWaveSquare';
import '@fortawesome/pro-light-svg-icons/faWifiSlash';
import '@fortawesome/pro-light-svg-icons/faWindowMinimize';
import '@fortawesome/pro-light-svg-icons/faChartBar';
import '@fortawesome/pro-light-svg-icons/faSlidersH';
import '@fortawesome/pro-light-svg-icons/faPageBreak';
import '@fortawesome/pro-light-svg-icons/faServer';
import '@fortawesome/pro-light-svg-icons/faTools';
import '@fortawesome/pro-light-svg-icons/faAnalytics';
import '@fortawesome/pro-light-svg-icons/faTrophy';
import '@fortawesome/pro-light-svg-icons/faDice';
import '@fortawesome/pro-light-svg-icons/faSwords';
import '@fortawesome/pro-light-svg-icons/faBoxingGlove';
import '@fortawesome/pro-light-svg-icons/faRandom';
import '@fortawesome/pro-light-svg-icons/faVideoPlus';
import '@fortawesome/pro-light-svg-icons/faFileAudio';
import '@fortawesome/pro-light-svg-icons/faMagic';
import '@fortawesome/pro-light-svg-icons/faSitemap';
import '@fortawesome/pro-light-svg-icons/faFiles';
import '@fortawesome/pro-light-svg-icons/faUserShakespeare';
import '@fortawesome/pro-light-svg-icons/faUserPilot';
import '@fortawesome/pro-light-svg-icons/faUserPilotTie';
import '@fortawesome/pro-light-svg-icons/faUserRobotXmarks';
import '@fortawesome/pro-light-svg-icons/faUserVisor';
import '@fortawesome/pro-light-svg-icons/faUserNinja';
import '@fortawesome/pro-light-svg-icons/faUserGear';
import '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import '@fortawesome/pro-light-svg-icons/faMessageBot';
import '@fortawesome/pro-light-svg-icons/faVolume';
import '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import '@fortawesome/pro-light-svg-icons/faImages';
import '@fortawesome/pro-light-svg-icons/faSwordLaser';
import '@fortawesome/pro-light-svg-icons/faSwordsLaser';
import '@fortawesome/pro-light-svg-icons/faHelmetBattle';
import '@fortawesome/pro-light-svg-icons/faUpRightAndDownLeftFromCenter';
import '@fortawesome/pro-light-svg-icons/faDownLeftAndUpRightToCenter';
import '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import '@fortawesome/pro-light-svg-icons/faPresentationScreen';
import '@fortawesome/pro-light-svg-icons/faFileInvoice';
import '@fortawesome/pro-light-svg-icons/faChalkboardTeacher';
import '@fortawesome/pro-light-svg-icons/faCircleDollar';
import '@fortawesome/pro-light-svg-icons/faPersonFairy';
import '@fortawesome/pro-light-svg-icons/faCubes';
import '@fortawesome/pro-light-svg-icons/faUserHeadset';
import '@fortawesome/pro-light-svg-icons/faPalette';
import '@fortawesome/pro-light-svg-icons/faChartMixed';
import '@fortawesome/pro-light-svg-icons/faBrainCircuit';
import '@fortawesome/pro-light-svg-icons/faImageLandscape';
import '@fortawesome/pro-light-svg-icons/faHexagonPlus';
import '@fortawesome/pro-light-svg-icons/faPrintMagnifyingGlass';
import '@fortawesome/pro-light-svg-icons/faShieldHalved';
import '@fortawesome/pro-light-svg-icons/faDiagramSubtask';
import '@fortawesome/pro-light-svg-icons/faHandshake';
import '@fortawesome/pro-light-svg-icons/faBullhorn';
import '@fortawesome/pro-light-svg-icons/faCogs';
import '@fortawesome/pro-light-svg-icons/faHeadset';
import '@fortawesome/pro-light-svg-icons/faMicroscope';
import '@fortawesome/pro-light-svg-icons/faScaleBalanced';
import '@fortawesome/pro-light-svg-icons/faTruck';
import '@fortawesome/pro-light-svg-icons/faBuildings';
import '@fortawesome/pro-light-svg-icons/faInputText';
import '@fortawesome/pro-light-svg-icons/faProjectDiagram';
import '@fortawesome/pro-light-svg-icons/faPaperclip';
import '@fortawesome/pro-light-svg-icons/faFileVideo';
import '@fortawesome/pro-light-svg-icons/faCircleChevronUp';
import '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import '@fortawesome/pro-light-svg-icons/faUnlockKeyhole';
import '@fortawesome/pro-light-svg-icons/faChartScatter3d';
import '@fortawesome/pro-light-svg-icons/faSidebar';
import '@fortawesome/pro-light-svg-icons/faGlobe';
import '@fortawesome/pro-light-svg-icons/faSquare';
import '@fortawesome/pro-light-svg-icons/faSquareRss';
import '@fortawesome/pro-light-svg-icons/faAsterisk';
import '@fortawesome/pro-light-svg-icons/faCircleUser';
import '@fortawesome/pro-light-svg-icons/faUpFromBracket';
import '@fortawesome/pro-light-svg-icons/faHouseLock';
import '@fortawesome/pro-light-svg-icons/faXmarkToSlot';
import '@fortawesome/pro-light-svg-icons/faRobot';
import '@fortawesome/pro-light-svg-icons/faMagicWandSparkles';
import '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import '@fortawesome/pro-light-svg-icons/faBook';
import '@fortawesome/pro-light-svg-icons/faImagePolaroid';
import '@fortawesome/pro-light-svg-icons/faVideo';
import '@fortawesome/pro-light-svg-icons/faCube';
import '@fortawesome/pro-light-svg-icons/faToolbox';
import '@fortawesome/pro-light-svg-icons/faTimer';
import '@fortawesome/pro-light-svg-icons/faThoughtBubble';
import '@fortawesome/pro-light-svg-icons/faSwap';
import '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import '@fortawesome/pro-light-svg-icons/faWandMagicSparkles';
import '@fortawesome/pro-light-svg-icons/faXmark';
import '@fortawesome/pro-light-svg-icons/faFileVector';
import '@fortawesome/pro-light-svg-icons/faWrench';
import '@fortawesome/pro-light-svg-icons/faVectorPolygon';
import '@fortawesome/pro-light-svg-icons/faClose';
import '@fortawesome/pro-light-svg-icons/faCircleXmark';
import '@fortawesome/pro-light-svg-icons/faCloud';
import '@fortawesome/pro-light-svg-icons/faPlanetMoon';
import '@fortawesome/pro-light-svg-icons/faListCheck';
import '@fortawesome/pro-light-svg-icons/faUnlock';
import '@fortawesome/pro-light-svg-icons/faCheck';
import '@fortawesome/pro-light-svg-icons/faCirclePlus';
import '@fortawesome/pro-light-svg-icons/faCircleMinus';
import '@fortawesome/pro-light-svg-icons/faWandSparkles';
import '@fortawesome/pro-light-svg-icons/faHardDrive';
import '@fortawesome/pro-light-svg-icons/faLightbulb';
import 'url';
import 'highlight.js';
import '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import 'lodash-es';
import 'react-native-markdown-display';

const WeightDistributionSlider = _ref => {
  let {
    onWeightsChange,
    initialWeights = {
      correctness: 33.33,
      reasoning: 33.33,
      context_usage: 33.34
    },
    containerStyle,
    sliderContainerStyle,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [weights, setWeights] = useState(initialWeights);
  const adjustWeights = (category, newValue) => {
    const oldValue = weights[category];
    const difference = newValue - oldValue;

    // Calculate remaining categories
    const remainingCategories = Object.keys(weights).filter(key => key !== category);

    // Distribute the difference proportionally among other categories
    const newWeights = {
      ...weights
    };
    newWeights[category] = newValue;
    const totalOthers = remainingCategories.reduce((sum, key) => sum + weights[key], 0);
    remainingCategories.forEach(key => {
      const proportion = weights[key] / totalOthers;
      newWeights[key] = Math.max(0, weights[key] - difference * proportion);
    });

    // Ensure total is exactly 100
    const total = Object.values(newWeights).reduce((sum, value) => sum + value, 0);
    if (Math.abs(total - 100) > 0.01) {
      const adjustment = (100 - total) / remainingCategories.length;
      remainingCategories.forEach(key => {
        newWeights[key] = Math.max(0, newWeights[key] + adjustment);
      });
    }
    setWeights(newWeights);
    onWeightsChange(newWeights);
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.container, containerStyle]
  }, Object.entries(weights).map(_ref2 => {
    var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
    let [category, value] = _ref2;
    return /*#__PURE__*/React__default.createElement(View, {
      key: category,
      style: [styles.sliderContainer, sliderContainerStyle]
    }, /*#__PURE__*/React__default.createElement(AppText, {
      style: styles.label,
      preventTranslation: true
    }, category.charAt(0).toUpperCase() + category.slice(1), ":", " ", value.toFixed(1), "%"), /*#__PURE__*/React__default.createElement(Slider, _extends({
      value: value,
      min: 0,
      max: 100,
      step: 0.1,
      onChange: newValue => adjustWeights(category, Number(newValue)),
      trackStyle: {
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary_hard
      },
      handleStyle: {
        borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.primary,
        backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.backgroundContrastColor
      }
    }, props)));
  }));
};
const styles = StyleSheet.create({
  container: {
    padding: 16,
    width: "100%"
  },
  sliderContainer: {
    marginBottom: 20
  },
  label: {
    marginBottom: 8,
    fontSize: 14,
    fontWeight: "500"
  }
});
WeightDistributionSlider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WeightDistributionSlider",
  "props": {
    "initialWeights": {
      "defaultValue": {
        "value": "{\n  correctness: 33.33,\n  reasoning: 33.33,\n  context_usage: 33.34,\n}",
        "computed": false
      },
      "required": false
    }
  }
};

export { WeightDistributionSlider as default };
